import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="user-form"
export default class extends Controller {
  static targets = ["distributorRow", "customerRow", "roleSelect"]

  connect() {
    this.toggleByRole()
  }

  toggleByRole() {
    const role = this.roleSelectTarget.value
    this.distributorRowTarget.classList.toggle("d-none", role !== "distributor")
    this.customerRowTarget.classList.toggle("d-none", role !== "customer")
  }

  toggleDistributor() {
    this.toggleByRole()
  }
}
